<template>
    <div class="hero-calc radius" v-if="visibleCalc">

        <div class="hero-calc__block">
            <h2 class="hero-calc__title">
                Займы на карту онлайн 24/7
            </h2>
            <a href="/documents" class="hero-calc__link">Условия кредитования</a>
        </div>


        <form @submit.prevent="send()" method="post">

            <input type="hidden" name="_token" v-model="xsrfToken">

            <div class="hero-calc__wrapper-range">

                <div class="input-name" id="slider-sum">

                    <p class="input-text">Выберите сумму</p>
                    <div class="input-label">
                        <span class="value slider-text">{{numberFormat(sumValue)}}</span>
                        <span class="rouble">₽</span>
                    </div>
                    <div class="calc-range slider-bar">
                        <input type="hidden" name="sum" v-model="sumValue">
                        <vue-slider
                            v-model="sumValue"
                            :min="sum.min"
                            :max="sum.max"
                            :interval="sum.step"
                            :dotSize="dotSize"
                            class="vue-sum-slider"
                            :tooltip-formatter="val => numberFormat(val)"/>
                    </div>

                </div>
                <div class="input-label-bottom">
                    <span class="value slider-text">{{numberFormat(sum.min)}} ₽</span>
                    <span class="value slider-text">{{numberFormat(sum.max)}} ₽</span>
                </div>
                <div class="input-name" id="slider-period">
                    <p class="input-text">На срок</p>
                    <div class="input-label">
                       <span class="value slider-text">{{numberFormat(periodValue)}}</span>
                       <span>{{numCase(periodValue,['день','дня','дней'])}}</span>
                    </div>
                    <div class="calc-range slider-bar">
                        <input type="hidden" name="period" v-model="periodValue">
                        <vue-slider
                            v-model="periodValue"
                            :min="period.min"
                            :max="period.max"
                            :interval="period.step"
                            :dotSize="dotSize"
                            :tooltip-formatter="val => numberFormat(val) + ' ' + numCase(val, ['день', 'дня', 'дней'])"/>
                    </div>

                </div>
                <div class="input-label-bottom">
                    <span class="value slider-text">{{numberFormat(period.min)}} день</span>
                    <span class="value slider-text">{{numberFormat(period.max)}} дней</span>
                </div>
                <div class="calc-detail">

                    <div class="calc-detail-left">
                        Возвращаете:
                        <span class="return-summ">
                            <span>{{numberFormat(returnSum)}}</span>
                            <span class="rouble">₽</span>
                        </span>
                    </div>

                    <div class="calc-detail-right">
                        До (включительно):
                        <span class="date return-date">{{returnDate | dayjs('D MMMM YYYY')}}</span>
                    </div>

                </div>


                <button type="submit" class="btn get-money-btn ">Получить деньги</button>
            </div>
        </form>


    </div>
</template>

<script>
    import VueSlider from 'vue-slider-component'
    import 'vue-slider-component/theme/antd.css'

    export default {
        name: "Calculator",
        inject: [],
        components: {
            VueSlider
        },
        props: {
            sum: {
                type: Object,
                default: function () {
                    return {
                        min: 1000,
                        max: 10000,
                        step: 1000,
                        default: 5000
                    }
                }
            },
            period: {
                type: Object,
                default: function () {
                    return {
                        min: 1,
                        max: 30,
                        step: 1,
                        default: 10
                    }
                }
            },
            percents: {
                type: Object,
                default: function () {
                    return {1: 1}
                },
            },
            showGetMoneyMethod: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                now: Date.now(),
                startTimer: null,
                dotSize: 16,
                gettingMoneyMethods: [
                    {label: 'На карту', value: 102392},
                    {label: 'Наличными', value: 102395},
                ]
            }
        },
        computed: {
            sumValue: {
                get () {
                    return this.$store.state.calcSum
                },
                set (value) {
                    this.$store.commit('calcSum', value)
                }
            },
            periodValue: {
                get () {
                    return this.$store.state.calcPeriod
                },
                set (value) {
                    this.$store.commit('calcPeriod', value)
                }
            },
            gettingMoneyMethod: {
                get () {
                    return this.$store.state.gettingMoneyMethod
                },
                set (value) {
                    this.$store.commit('gettingMoneyMethod', value)
                }
            },
            xsrfToken: function () {
                let token = document.head.querySelector('meta[name="csrf_token"]');
                return token.content;
            },
            visibleCalc: function () {
                return this.sumValue !== null && this.periodValue !== null;
            },
            // Дата возврата
            returnDate: function () {
                let giveDay = new Date(this.now + (this.periodValue * 24 * 3600 * 1000));
                return giveDay;
            },
            // Сумма возврата
            returnSum: function () {
                let pr, res = this.sumValue, percents = this.percents;
                for (let i = 1; i <= this.periodValue; i++) {
                    for (let p in percents) {
                        p = parseInt(p);
                        if (i == p) pr = percents[p];
                        else if (i < p) break;
                    }
                    res += this.sumValue * (pr / 100)
                }
                res = Math.ceil(res * 100) / 100;
                return res;
            },
            // Переплата
            overpayment: function () {
                let dif = this.returnSum - this.sumValue;
                dif = Math.ceil(dif * 100) / 100;
                return dif;
            },
            // дынные для таймера
            timer: function () {
                let maxMin = 15;
                let maxSecond = maxMin * 60;
                let now = _dayjs(this.now);
                let start = _dayjs(this.startTimer);
                let diff = now.diff(start, 'second');

                let seconds = maxSecond > diff ? maxSecond - diff : 0;
                let minutes = Math.floor(seconds / 60);

                let percent = diff / (maxSecond / 100);
                if (percent > 100) percent = 100;

                let result = {
                    percent: Math.ceil(percent),
                    minutes: minutes,
                    seconds: seconds,
                    data: {
                        minutes: minutes.toString().padStart(2, '0'),
                        seconds: Math.floor(seconds % 60).toString().padStart(2, '0'),
                    }
                };
                return result;
            }
        },
        methods: {
            send: function () {
                this.$emit('submit');

            },
            numberFormat: function (number) {
                return new Intl.NumberFormat('ru-RU').format(number);
            },
            numCase: function (value, words) {
                value = value.toString();
                var n = parseInt(value.slice(-2));
                if (n > 19) {
                    n %= 10;
                }
                switch (n) {
                    case 1:
                        var text = words[0];
                        break;
                    case 2:
                    case 3:
                    case 4:
                        var text = words[1];
                        break;

                    default:
                        var text = words[2];
                }
                return text;
            },
        },
        created() {
            var app = this;
            setInterval(function () {
                app.now = Date.now();
            }, 1000);

            axios.get('/get-calc-start-timer', {params: {showLoading: false}}).then(function (result) {
                if (result.data.status) {
                    app.startTimer = result.data.data;
                }
            });
            if(!this.sumValue) this.sumValue = this.sum.default;
            if(!this.periodValue) this.periodValue = this.period.default;
        },
    }
</script>
